const MoveResource = {
  methods: {
    moveResource(indexA, indexB, arr) {
      arr.splice(indexB, 0, arr.splice(indexA, 1)[0])
    },
  },
}

export default MoveResource
